import { FontSizeTheme } from '@kite-js/theme-types';

const tallerLineHeights: FontSizeTheme = {
    XXXXL: '70px',
    XXXL: '52px',
    XXL: '32px',
    XL: '28px',
    L: '24px',
    M: '20px',
    S: '18px',
    XS: '16px',
};

export default tallerLineHeights;
